import 'mdb-vue-ui-kit/css/mdb.min.css'
import { createApp } from 'vue'
import App from './App.vue'
import { VueCookieNext } from 'vue-cookie-next'

// set default config
VueCookieNext.config({ expire: '7d' })
VueCookieNext.setCookie('theme', 'default')
VueCookieNext.setCookie('hover-time', { expire: '1s' })
createApp(App).use(VueCookieNext).mount('#app')